import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Prevent third-party DOM manipulation (Google Translate, Grammarly, etc.)
// from crashing React 19's reconciler. These tools wrap text nodes in
// <font>/<span> tags, breaking insertBefore/removeChild reference nodes.
if (typeof Node !== 'undefined') {
  const origInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, refNode) {
    if (refNode && refNode.parentNode !== this) {
      return this.appendChild(newNode);
    }
    return origInsertBefore.call(this, newNode, refNode);
  };

  const origRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      return child;
    }
    return origRemoveChild.call(this, child);
  };
}



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
